<script lang="ts">
import { stripSiteDomain } from '$lib/utils/url.js';
import { ETitleFontSizes } from '../../../config/enums.js';
import Link from '../../atoms/Link/Link.svelte';

interface Props {
    header?: string;
    headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    titleSize?: string;
    ctaTo?: string;
    ctaText?: string;
    withPageMargins?: boolean;
}

let {
    header = '',
    headingLevel = 'h2',
    titleSize = ETitleFontSizes.H2,
    ctaTo = '',
    ctaText = '',
    withPageMargins = false,
}: Props = $props();

// Transform URL from Builder.io
const transformedCtaTo = $derived(stripSiteDomain(ctaTo));
const titleSizeClassName = $derived(`block-header__header--${titleSize}`);
</script>

{#if header?.trim() || (transformedCtaTo?.trim() && ctaText?.trim())}
<div class="block-header" class:block-header--with-page-margins={withPageMargins} class:block-header--has-cta={transformedCtaTo?.trim() && ctaText?.trim()}>
    <svelte:element this={headingLevel} class="block-header__header {titleSizeClassName}">
        {header}
    </svelte:element>
    {#if transformedCtaTo?.trim() && ctaText?.trim()}
        <Link
            to={transformedCtaTo}
            class="button button--inverse button--with-fixed-inverse-border block-header__cta"
        >
            {#snippet text()}

                    {ctaText}

                {/snippet}
        </Link>
    {/if}
</div>
{/if}

<style lang="scss">
    @use '/src/scss/global-constants/typography';
    @use 'sass-mq/mq' as *;

    .block-header {
        margin-bottom: 2.4rem;
        position: relative;

        @include mq($from: tablet) {
            margin-bottom: 5rem;
        }

        &--with-page-margins {
            padding-left: var(--layout-pagegrid-margin);
            padding-right: var(--layout-pagegrid-margin);
        }

        &--has-cta {
            padding-bottom: 3.2rem;

            @include mq($from: tablet) {
                padding-bottom: 0;
            }
        }

        &__header {
            max-width: 30ch;

            &--h1 {
                @include typography.display-xl;
            }

            &--h1-5 {
                @include typography.display-hero;
            }

            &--h2 {
                @include typography.display-lg;
            }

            &--h3 {
                @include typography.display-md;
            }

            &--h4 {
                @include typography.heading-lg;
            }

            &--h5 {
                @include typography.heading-md;
            }
        }
    }

    .block-header :global(.block-header__cta) {
        bottom: 0;
        left: 0;
        position: absolute;

        @include mq($from: tablet) {
            left: auto;
            right: 0;
        }
    }

    .block-header--has-cta .block-header__header {
        margin-bottom: 2.4rem;

        @include mq($from: tablet) {
            margin-bottom: 3rem;
        }
    }
</style>
